import React, { useState, useEffect, useMemo } from "react";
import "./App.css";
import Main from "./App/Main";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

import About from './App/about'
import Work from "./App/Work";
import CaseStudyPage from "./App/caseStudyMain";
import Dumpyard from "./App/dumpyard";
import Logo from "./Assets/logo_harshit.svg";

const LOADER_GREETINGS = ["नमस्ते","Hello", "Bonjour", "Hola", "Ciao" ];
const LOADER_GRID_COLUMNS = 22;
const LOADER_GRID_ROWS = 13;
const LOADER_GRID_CELLS = LOADER_GRID_COLUMNS * LOADER_GRID_ROWS;
const LOADER_CELL_TRIM_DIRECTIONS = [
  "trim-left",
  "trim-right",
  "trim-top",
  "trim-bottom",
  "trim-top-left",
  "trim-top-right",
  "trim-bottom-left",
  "trim-bottom-right",
];

function App() {
  const [isLoaderHiding, setIsLoaderHiding] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const [greetingIndex, setGreetingIndex] = useState(0);

  // Each grid cell trims itself away toward a random edge, at its own
  // random opacity, starting near-immediately at mount and spread tightly
  // across the run (no lag before trimming visibly begins) — pixelating
  // apart in the background while the greeting text cycles, landing at
  // 1.9s together with the greeting box and background fade so the whole
  // loader wraps up inside a 2s lifecycle. Computed once so it doesn't
  // reshuffle on re-render.
  const cellDelays = useMemo(
    () =>
      Array.from({ length: LOADER_GRID_CELLS }, () => Math.random() * 1.3),
    [],
  );
  const cellDurations = useMemo(
    () =>
      Array.from(
        { length: LOADER_GRID_CELLS },
        () => 0.3 + Math.random() * 0.3,
      ),
    [],
  );
  // Each cell blinks (infinite opacity flicker) between a low floor and its
  // own random peak — a randomized "filling in" mosaic — until it either
  // trims away or the whole loader fades out.
  const cellOpacityMax = useMemo(
    () =>
      Array.from(
        { length: LOADER_GRID_CELLS },
        () => 0.05 + Math.random() * 0.05,
      ),
    [],
  );
  const cellBlinkDurations = useMemo(
    () =>
      Array.from(
        { length: LOADER_GRID_CELLS },
        () => 0.5 + Math.random() * 0.6,
      ),
    [],
  );
  const cellDirections = useMemo(
    () =>
      Array.from(
        { length: LOADER_GRID_CELLS },
        () =>
          LOADER_CELL_TRIM_DIRECTIONS[
            Math.floor(Math.random() * LOADER_CELL_TRIM_DIRECTIONS.length)
          ],
      ),
    [],
  );

  useEffect(() => {
    document.body.style.overflow = "hidden";

    const greetingInterval = setInterval(() => {
      setGreetingIndex((i) => (i + 1) % LOADER_GREETINGS.length);
    }, 300);

    const hideTimer = setTimeout(() => {
      setIsLoaderHiding(true);
      document.body.style.overflow = "";
      clearInterval(greetingInterval);
    }, 1550);

    const removeTimer = setTimeout(() => {
      setShowLoader(false);
    }, 2000);

    return () => {
      clearInterval(greetingInterval);
      clearTimeout(hideTimer);
      clearTimeout(removeTimer);
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <div>
      {showLoader && (
        <div className={`site-loader ${isLoaderHiding ? "hide" : ""}`}>
          <div
            className="site-loader-grid"
            style={{
              gridTemplateColumns: `repeat(${LOADER_GRID_COLUMNS}, 1fr)`,
              gridTemplateRows: `repeat(${LOADER_GRID_ROWS}, 1fr)`,
            }}
          >
            {cellDelays.map((delay, i) => (
              <div
                className={`site-loader-cell ${cellDirections[i]}`}
                key={i}
                style={{
                  "--cell-delay": `${delay}s`,
                  "--cell-duration": `${cellDurations[i]}s`,
                  "--cell-blink-duration": `${cellBlinkDurations[i]}s`,
                  "--cell-opacity-max": cellOpacityMax[i],
                }}
              />
            ))}
          </div>

          <div className="site-loader-content">
            <div className="site-loader-logo">
              <img src={Logo} alt="" />
            </div>

            <div className="site-loader-greeting-box">
              <span
                key={greetingIndex}
                className="site-loader-greeting"
              >
                {LOADER_GREETINGS[greetingIndex]}
              </span>
            </div>
          </div>
        </div>
      )}

      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<Main />} />
          <Route exact path="/archives" element={<Dumpyard/>} />
          <Route path="/about" element={<About />} />
          <Route exact path="case-study/:id" element={<CaseStudyPage/>} />
          <Route path="*" element={<Navigate to="/" />} />
          <Route exact path="/work" element={<Work />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
